// L'EFFACEUR — Configuration i18n (react-i18next)
// Français = langue par défaut. Anglais/Espagnol à ajouter quand demandé.
//
// Usage dans un composant :
//   import { useTranslation } from 'react-i18next';
//   const { t } = useTranslation();
//   <h1>{t('landing.hero_title')}</h1>
//
// Pour ajouter une langue, dupliquer fr.json en en.json et traduire, puis l'importer ici.

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import fr from './locales/fr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      // en: { translation: en },  // à ajouter plus tard
    },
    fallbackLng: 'fr',
    lng: 'fr',
    interpolation: {
      escapeValue: false, // React escape déjà
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
